export default __webpack_public_path__ + "static/195-8dd2d32a3963764b7354a8114abc0b31.jpg";